<div id="signinContainer">
     <section class="bg-light d-flex align-items-end" id="main">
          <div class="container">
               <div class="row d-flex justify-content-center align-items-stretch">
                    <div class="col-lg-4">
                         <div
                              class="card text-white shadow-sm d-flex align-items-stretch border-0 rounded-0 bg-brand-dark h-100">

                              <div class="card-body">
                                   <div id="errorBlock" *ngIf="showError">
                                        <div class="alert alert-danger">
                                             <p>
                                                  <span [innerHtml]="'LoginUnsuccessfulStart' | translator: 'base'">
                                                       Login was unsuccessful. Please
                                                  </span>
                                                  <a routerLink="/customerSupport" (click)="scrollToTop()"
                                                       [innerHtml]="'ContactSupportLinkText' | translator: 'base'"
                                                       [title]="'ContactSupportLinkText' | translator: 'base'"
                                                       id="contactUs" name="contactUs" class="alert-link">contact the
                                                       PSP Customer Service team</a>
                                                  <span [innerHtml]="'LoginUnsuccessfulEnd' | translator: 'base'">
                                                       for assistance.
                                                  </span>
                                             </p>
                                        </div>
                                   </div>
                                   <div>
                                        <p class="d-flex align-items-center mb-1">
                                             <i class="fa-solid fa-circle-play me-2" aria-hidden="true"></i>
                                             <a href="https://tylertech.wistia.com/medias/nrc1maa2b5" target="_blank"
                                                  id="linkForgotPassword" name="linkForgotPassword"
                                                  [title]="'NeedHelp' | translator: 'base'"
                                                  [innerHtml]="'NeedHelp' | translator: 'base'">Forgot your password?
                                             </a>
                                        </p>
                                        <p class="d-flex align-items-center m-0">
                                             <i class="fa-solid fa-circle-play me-2" aria-hidden="true"></i>
                                             <a href="https://tylertech.wistia.com/medias/h32vcocq9r" target="_blank"
                                                  [innerHtml]="'PasswordVideo' | translator: 'base'"
                                                  [attr.aria-label]="'PasswordVideoTitle' | translator: 'base'"
                                                  [title]="'PasswordVideoTitle' | translator: 'base'"
                                                  id="forgotPwdVideo" name="forgotPwdVideo">Password not working?
                                             </a>
                                        </p>
                                   </div>
                              </div>
                              <div class="card-footer">
                                   <div class="form-group d-flex mb-0">
                                        <button *ngIf="!shouldLogout" class="btn btn-outline-primary"
                                             name="closeMonitoringInfo" id="closeMonitoringInfo"
                                             (click)="redirectToLoginGov()"
                                             [innerHtml]="'Login' | translator: 'base'">
                                             LOGIN
                                        </button>
                                        <button *ngIf="shouldLogout" class="btn btn-outline-primary"
                                             name="closeMonitoringInfo" id="closeMonitoringInfoLogout"
                                             (click)="logoff()"
                                             [innerHtml]="'Logout' | translator: 'base'">
                                             LOGOUT
                                        </button>
                                   </div>
                              </div>
                              <!-- <div class="modal-footer" *ngIf="ShowFroceLogoff">
                                   <button 
                                   class="btn btn-primary"
                                   name="closeMonitoringInfo"
                                   id="closeMonitoringInfoLogout"
                                   (click)="logoff()"
                                   >
                                   <span>LOGOUT</span>
                                   </button>
                              </div> -->
                         </div>
                    </div>
               </div>
          </div>
     </section>

     <ng-template #LoginGovErrorModal let-modal>
          <div class="modal-header">
               <h3 id="loginGovErrorModalTitle" class="modal-title" slot="header"
               [innerHtml]="'PSPDownHeader' | translator: 'base'">
                    PSP Cannot be Accessed at This Time
               </h3>
          </div>
          <div class="modal-body">
               <p [innerHtml]="'PSPDown' | translator: 'base'">
                    Login.gov is experiencing technical issues. They are aware of the issue and working on a resolution. Please try back later.
               </p>
          </div>
          <div class="modal-footer">
               <button class="btn btn-primary" name="closeMonitoringInfo" id="closeMonitoringInfoLogout"
                    (click)="logoff()" [innerHtml]="'Close' | translator: 'base'">
                    Close
               </button>
          </div>
     </ng-template>
</div>